<template>
<v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <template v-slot:activator="{ on }">
        <v-icon small class="mr-2" @click="dialog = true" v-on="on">mdi-eye</v-icon>
    </template>
    <v-card>
        <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialog = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>
            <code v-if="abono.codigoAbono">{{ abono.codigoAbono }}</code>
            <span v-if="abono.codigoAbono"> · </span>
            Factura: <code>{{ abono.factura }}</code>
            <code v-if="abono.abonado">- Abonado</code>
            <code v-if="abono.numeroAbonoPyme">| Nº Pyme: {{ abono.numeroAbonoPyme }}</code>
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-list five-line subheader>
            <v-subheader class="headline mb-1 mt-2">Detalles del Abono - Fecha: {{abono.fecha}}
                <v-spacer></v-spacer>
                <div class="overline"> Ultima Mod: {{ultimaMod}} | {{abono.isla}}</div>
            </v-subheader>
            <v-divider></v-divider>

            <v-list-item>
                <v-row style="max-width: 100%;">
                    <v-col cols="6">
                        <v-row>
                            <v-col cols="6">
                                <v-list-item-content>
                                    <v-list-item-title>Identificador</v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ abono.codigoAbono ? abono.codigoAbono : 'Sin identificador (abono anterior)' }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-col>
                            <v-col cols="6">
                                <v-list-item-content>
                                    <v-list-item-title>Comercial</v-list-item-title>
                                    <v-list-item-subtitle>{{abono.comercial}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-list-item-content>
                                    <v-list-item-title>Cliente</v-list-item-title>
                                    <v-list-item-subtitle>{{abono.cliente}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-col>
                        </v-row>

                    </v-col>
                    <v-col cols="6">
                        <v-row>
                            <v-col cols="12">
                                <v-list-item-content>
                                    <v-list-item-title>Productos a Abonar</v-list-item-title>
                                    <v-list-item-subtitle v-html="abono.productos" style="white-space: normal;"></v-list-item-subtitle>
                                </v-list-item-content>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-list-item>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>Motivo</v-list-item-title>
                    <v-list-item-subtitle>{{abono.motivo}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list-item>
                <v-row>
                    <v-col cols="3">
                        <v-checkbox disabled v-model="abono.activoWeb" label="Activo en Web"></v-checkbox>
                    </v-col>
                    <v-col cols="3">
                        <v-checkbox disabled v-model="abono.cambioPrecio" label="Cambio de Precio"></v-checkbox>
                    </v-col>
                    <v-col cols="3">
                        <v-checkbox disabled v-model="abono.bajoPedido" label="Bajo Pedido"></v-checkbox>
                    </v-col>
                    <v-col cols="3">
                        <v-checkbox disabled v-model="abono.precintado" label="Precintado"></v-checkbox>
                    </v-col>
                </v-row>
            </v-list-item>
            <v-list-item>
                <v-col cols="12">
                    <span>¿El/los artículo/s fueron entregados al cliente?: {{abono.noEntregadoCliente ? abono.noEntregadoCliente : "No marcado"}}</span>
                </v-col>
            </v-list-item>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>Observaciones</v-list-item-title>
                    <v-list-item-subtitle>{{abono.observComercial}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list disabled>
            <v-subheader>
                Autorizaciones
                <div class="text-left d-flex align-center">
                    <v-chip class="ma-3" :color="abono.color" label text-color="white">
                        <v-icon left>mdi-label</v-icon>
                        {{abono.autorizado}}
                    </v-chip>
                </div>
            </v-subheader>
            <v-list-item-group color="primary">
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>Condiciones</v-list-item-title>
                        <v-list-item-subtitle class="mt-2">{{abono.condiciones}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </v-list>
        <v-divider></v-divider>
        <v-list disabled v-if="abono.abonado || abono.numeroAbonoPyme">
        <v-subheader>Datos de Abono</v-subheader>
        <v-list-item>
            <v-list-item-content>
            <v-list-item-title>Nº de abono Pyme</v-list-item-title>
            <v-list-item-subtitle>
                {{ abono.numeroAbonoPyme ? abono.numeroAbonoPyme : 'No informado' }}
            </v-list-item-subtitle>
            </v-list-item-content>
            <v-chip v-if="abono.abonado" color="green" text-color="white" class="ma-2" label>
            Abonado
            </v-chip>
        </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list disabled v-if="abono.recogido || abono.rechazoAlmacen">
            <v-subheader>Almacén
                <v-chip v-if="abono.rechazoAlmacen" class="ma-3" color="red" label text-color="white">
                    Rechazado
                </v-chip>
                <v-chip v-else-if="abono.recogido" class="ma-3" color="deep-orange" label text-color="white">
                    Recogido
                </v-chip>
            </v-subheader>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>Observaciones de almacén</v-list-item-title>
                    <v-list-item-subtitle style="white-space: normal;">{{ abono.observAlmacen ? abono.observAlmacen : 'Sin observaciones' }}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list disabled>
            <v-subheader>Servicio Técnico
                <div class="text-left d-flex align-center">
                    <v-chip v-if="abono.autorizado == 'Aceptado'" class="ma-3" color="purple" label text-color="white">
                        <v-icon left>mdi-label</v-icon>

                        {{abono.tramitar}}
                    </v-chip>
                </div>
            </v-subheader>
            <v-list-item-group color="primary">
                <v-list-item>
                    <v-row>
                        <v-col cols="6">
                            <v-list-item-content>
                                <v-list-item-title>¿Ha sido abierto?</v-list-item-title>
                                <v-list-item-subtitle>{{abono.abierto}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-col>
                        <v-col cols="6">
                            <v-checkbox disabled v-model="abono.estado" label="¿Se puede Poner a la Venta?"></v-checkbox>
                        </v-col>

                    </v-row>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>Observaciones:</v-list-item-title>
                        <v-list-item-subtitle>{{abono.observRevision}}</v-list-item-subtitle>
                        <v-divider></v-divider>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="abono.images">
                    <v-list-item-content>
                        <v-list-item-title>Imagenes:</v-list-item-title>
                        <v-card class="mt-3">
                            <v-container fluid>
                                <v-row>
                                    <v-col v-for="(img, idx) in abono.images" :key="idx" class="d-flex child-flex" cols="3">
                                        <v-card flat tile class="d-flex">
                                            <v-img :src="img" :lazy-src="img" aspect-ratio="1" class="grey lighten-2"></v-img>
                                        </v-card>
                                    </v-col>
                                </v-row>

                            </v-container>
                        </v-card>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </v-list>
    </v-card>
</v-dialog>
</template>

<script>
import {
    mapActions
} from 'vuex'
export default {
    name: 'Detalles',
    data() {
        return {
            dialog: false,
            notifications: false,
            sound: true,
            widgets: false,
            checkboxAutorizado: true,
            ultimaMod: [],
            index: null
        }
    },
    components: {},
    created() {
        this.ultimaMod = new Date(this.abono.ultimaMod)
    },
    methods: {
        showGallery(img) {
            console.log(img);
        }
    },
    props: ['abono'],
}
</script>
